<script lang="ts">
  import Form from "$components/form/Form/Form.svelte";
  import InputField from "$components/form/Fields/InputField.svelte";
  import ImageField from "$components/form/Fields/ImageField.svelte";
  import SelectField from "$components/form/Fields/SelectField.svelte";
  import Button from "$components/+blocks/Button/Button.svelte";
  import { reportError } from "app/utils/errors";
  import { session } from "app/stores/auth";
  import { alerts } from "app/stores/alert";
  import { type SelectOption, Theme } from "models/shared-types";
  import type { PrivateWriteUser } from "@outverse-video/outverse-api-client-lib";
  import type { UserPreferencesStore } from "app/stores/userPreferences";

  export let user: PrivateWriteUser;
  export let userPreferences: UserPreferencesStore;

  let isSubmitting = false;
  const formId = "onboarding-form";
  const selectOptions: SelectOption[] = [
    { id: 0, name: "Light", value: Theme.Light },
    { id: 1, name: "Dark", value: Theme.Dark },
  ];

  async function handleSubmit(data: { profileImage: string; displayName: string }) {
    isSubmitting = true;
    try {
      await session.updateUser({
        profileImage: data.profileImage,
        handle: data.displayName,
      });
    } catch (e: any) {
      reportError(e);
      alerts.error("Unable to onboard user.");
    } finally {
      isSubmitting = false;
    }
  }
</script>

<Form
  id={formId}
  name="onboarding-form"
  class="flex flex-col p-8"
  on:submit={(e) => handleSubmit(e.detail)}
  defaultValues={{
    profileImage: user?.profileImage,
    displayName: user?.handle,
    theme: $userPreferences.theme,
  }}
>
  <div class="flex w-full flex-col gap-3">
    <div class="text-sm font-medium text-neutral-600 dark:text-neutral-200">
      Profile photo / Display name
    </div>
    <div class="flex grow gap-3">
      <ImageField labelHidden name="profileImage" size="size-[42px]" radius="rounded-md" />
      <InputField
        name="displayName"
        labelHidden
        wrapperClassname="grow"
        validationRules={{
          required: "This is required.",
          pattern: {
            value: /^[^\s]+(?:$|.*[^\s]+$)/,
            message: "Your display name cannot start with blank spaces",
          },
          minLength: {
            value: 2,
            message: "Your display name must be at least two characters",
          },
        }}
      />
    </div>
  </div>
  <SelectField
    name="theme"
    label="Interface theme"
    options={selectOptions}
    on:change={(e) => userPreferences.setTheme(e.detail.value)}
  />
  <Button
    form={formId}
    size="large"
    disabled={isSubmitting}
    htmlButtonType="submit"
    variant="system"
    label="Continue"
    isFullWidth
  />
</Form>
